/**
 * House関連のStoreで使用するStateをここで定義する
 *
 * Copyright (c) 2018-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'
import LocalDate from '../../domain/type/Date'

const _eventScheduleState = {
  id: '',
  title: '',
  start_date: '',
  end_date: '',
  hotel_id: '',
  room_id: '',
  reservation_id: '',
  memo: ''
}

class EventScheduleState extends Record(_eventScheduleState) {
  mergeModel(model) {
    const start_date = new LocalDate(model.start_date)
    const end_date = new LocalDate(model.end_date)
    return this.merge({
      id: model.id,
      title: model.title,
      start_date: start_date.format('yyyy/MM/dd'),
      end_date: end_date.format('yyyy/MM/dd'),
      hotel_id: model.hotel_id,
      room_id: model.room_id,
      memo: model.memo
    })
  }
}

export { EventScheduleState }
